<template>
    <div class="flex-1 animate-pulse">
        <div class="relative">
            <div
                class="h-[250px] w-full rounded bg-gray-200 object-cover md:h-[500px] md:w-full lg:h-[250px] xl:my-[20px] xl:h-[350px] 2xl:h-[475px]"></div>
            <div class="absolute bottom-4 left-2 flex flex-col space-y-1 md:space-y-2">
                <div class="h-4 w-10 rounded bg-gray-200 md:w-16"></div>
                <div class="h-4 w-10 rounded bg-gray-200 md:w-16"></div>
            </div>
        </div>
        <div class="mb-1 mt-2 h-4 w-full rounded bg-gray-200 leading-5 lg:text-sm"></div>
        <div class="mb-1 h-4 w-3/4 rounded bg-gray-200 leading-5 lg:text-sm"></div>
        <div class="h-4 w-1/2 rounded bg-gray-200 text-sm font-bold leading-6 tracking-[0.7px] lg:text-base"></div>
    </div>
</template>
